import flapClientFactory from 'Utils/api/flap-client-factory';

/**
 * Axios instance to make Flap requests from web-u client to web-u server
 */
const flap = flapClientFactory('FLAP', '/api/v2');
export default flap;
